import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import "./ScoreRule.scss";
import ScoreRuleForm from "../Forms/ScoreRule";
import { DateTimeFormat } from "../../helpers/utils";
import { ReactSVG } from "react-svg";
import { Link } from "react-router-dom";
import { fetchScoreRule, updateScoreRule } from "../../actions/scoreRule";

const ScoreRulePage = () => {
	const { id } = useParams();
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [scoreRuleId, setScoreRuleId] = useState(null);
	const [questionId, setQuestionId] = useState(null);
	const { status, scoreRule } = useSelector((state) => state.fetchScoreRule);
	const { scoreRuleUpdate } = useSelector((state) => state.updateScoreRule);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleEdit = () => {
		showModal();
		setScoreRuleId(scoreRule.id);
		setQuestionId(scoreRule.question_id);
		const newRecord = { ...scoreRule };
		const newProductIds = newRecord.product_ids
			? newRecord.product_ids.ids
			: null;
		const productDescription = newRecord.product_ids
			? newRecord.product_ids.description
			: null;
		const productStatus = newRecord.product_ids
			? newRecord.product_ids.status
			: null;
		const productRecommendation = newRecord.product_ids
			? newRecord.product_ids.recommendation
			: null;
		newRecord.product_ids = newProductIds;
		newRecord.product_description = productDescription;
		newRecord.product_status = productStatus;
		newRecord.product_recommendation = productRecommendation;
		form.setFieldsValue(newRecord);
	};

	const handleSubmitForm = (values) => {
		const newValues = { ...values };
		const newProduct = {
			ids: values.product_ids,
			description: values.product_description,
			status: values.product_status,
			recommendation: values.product_recommendation,
		};
		newValues.product_ids = values.product_ids ? newProduct : null;
		delete newValues.product_description;
		delete newValues.product_status;
		delete newValues.product_recommendation;

		dispatch(updateScoreRule(scoreRuleId, newValues));
		handleOk();
	};

	useEffect(() => {
		dispatch(fetchScoreRule(id));
	}, []);

	useEffect(() => {
		if (scoreRuleUpdate) dispatch(fetchScoreRule(id));
	}, [scoreRuleUpdate]);

	return (
		<div id="score-rule-container">
			<div className="page-header">
				<h2 className="page-header-title">Score Rule Details</h2>
			</div>
			<div className="page-header-details-actions">
				<Link to="/score-rules">
					<Button type="link" className="btn btn-back">
						<ReactSVG src="/icons/arrow-left.svg" />
						Back
					</Button>
				</Link>
				<Button
					type="primary"
					className="btn-primary"
					onClick={() => handleEdit()}
				>
					Edit
					<ReactSVG src="/icons/edit.svg" />
				</Button>
			</div>
			{status === "SUCCEEDED" && (
				<div className="page-content">
					<div className="page-details-section">
						<div>
							<div className="box">
								<div className="box-header">
									<h2 className="box-title">Details</h2>
								</div>
								<div className="box-content">
									<div className="details-item">
										<label>Question Name</label>
										<div className="text">{scoreRule.question_name}</div>
									</div>
									<div className="details-item">
										<label>Category</label>
										<div className="text">{scoreRule.survey_category_name}</div>
									</div>
									<div className="details-item">
										<label>Type</label>
										<div
											className="text"
											style={{ textTransform: "capitalize" }}
										>
											{scoreRule.type}
										</div>
									</div>
									<div className="details-item">
										<label>Score</label>
										<div className="text">{scoreRule.score}</div>
									</div>
									<div className="details-item">
										<label>Min Length</label>
										<div className="text">{scoreRule.min_length}</div>
									</div>
									<div className="details-item">
										<label>Max Length</label>
										<div className="text">{scoreRule.max_length}</div>
									</div>
									{scoreRule.product_ids && (
										<Fragment>
											<div className="details-item">
												<label>Product IDs</label>
												<div className="text">
													{scoreRule.product_ids.ids.join(", ")}
												</div>
											</div>
											<div className="details-item">
												<label>Product Description</label>
												<div className="text">
													{scoreRule.product_ids.description}
												</div>
											</div>
											<div className="details-item">
												<label>Product Status</label>
												<div className="text">
													{scoreRule.product_ids.status}
												</div>
											</div>
											<div className="details-item">
												<label>Recommendation</label>
												<div className="text">
													{scoreRule.product_ids.recommendation}
												</div>
											</div>
										</Fragment>
									)}
									<div className="details-item">
										<label>Updated At</label>
										<div className="text">
											{DateTimeFormat(scoreRule.updated_at)}
										</div>
									</div>
									<div className="details-item">
										<label>Created At</label>
										<div className="text">
											{DateTimeFormat(scoreRule.created_at)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<Modal
				className="add-category-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<ScoreRuleForm
					form={form}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
					questionId={questionId}
				/>
			</Modal>
		</div>
	);
};

export default ScoreRulePage;
